<section class="p-2 p-md-4">
  <div class="card mb-4">
    <div class="card-header bg-white">
      <h3>Dados da consulta</h3>
    </div>
    <div class="card-body row">
      <div class="col-12 col-lg-12 p-2">
        <label for="nome">Nome</label>
        <input type="text" autocomplete="false" class="form-control input-validate" name="nome" id="nome"
          [formControl]="form.controls.nome">
        <app-msg-erro [control]="form.controls.nome"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-12 p-2">
        <label for="descricao">Descrição</label>
        <input type="text" autocomplete="false" class="form-control input-validate" name="descricao" id="descricao"
          [formControl]="form.controls.descricao">
        <app-msg-erro [control]="form.controls.descricao"></app-msg-erro>
      </div>
    </div>

    <div class="card-header bg-white">
      <h3>Insumos</h3>
    </div>
    <div class="card-body">
      <div class="row mb-4">
        <div class="col p-2">
          <label for="codigo">Código</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="codigo"
            id="codigo" [formControl]="form.controls.codigo">
          <app-msg-erro [control]="form.controls.codigo"></app-msg-erro>
        </div>
        <div class="col p-2">
          <label for="insumo">Nome</label>
          <input type="text" autocomplete="false" class="form-control input-validate" name="insumo"
            id="insumo" [formControl]="form.controls.insumo">
          <app-msg-erro [control]="form.controls.insumo"></app-msg-erro>
        </div>
        <div class="col-lg-1 p-2 m-auto m-20px">
          <button class="btn btn-sm btn-icon btn-success rounded-circle m-auto" (click)="addInsumos()">
            <i class="mdi mdi-plus"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 p-2">
          <table class="table bg-light rounded">
            <thead class="text-center" *ngIf="listaInsumos.length > 0">
              <tr>
                <th>Código</th>
                <th>Nome</th>
                <th class="acao-tabela">Ações</th>
              </tr>
            </thead>
            <tbody class="text-center">
              <tr *ngIf="listaInsumos.length == 0">
                <td class="text-center py-5 text-secondary w-500" colspan="7">
                  Sem registros
                </td>
              </tr>
              <tr *ngFor="let l of listaInsumos">
                <td>{{ l.codigo }}</td>
                <td>{{ l.nome }}</td>
                <td class="d-flex align-items-center justify-content-end">
                  <span data-toggle="tooltip" data-placement="bottom" title="Editar">
                  <button (click)="editInsumo(l.id)" class="btn btn-sm btn-icon btn-primary" title="EDITAR">
                    <i class="mdi mdi-pencil"></i>
                  </button></span>
                  <span data-toggle="tooltip" data-placement="bottom" title="Excluir">
                  <button (click)="delInsumo(l.id)" class="btn btn-sm btn-danger btn-icon mx-1" title="DELETAR">
                    <i class="mdi mdi-delete"></i>
                  </button></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end card-footer bg-white text-muted">
      <button [disabled]="form.invalid" class="btn btn-lg px-5 btn-success" (click)="submitForm()">
        <span>Salvar</span>
      </button>
    </div>
  </div>
</section>